(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name maleFemaleDiscrepancy.controller:MaleFemaleDiscrepancyCtrl
   *
   * @description
   *
   */
  angular
    .module('maleFemaleDiscrepancy')
    .controller('MaleFemaleDiscrepancyCtrl', MaleFemaleDiscrepancyCtrl);

  function MaleFemaleDiscrepancyCtrl(maleFemaleDiscrepancyService, MessageService) {
    var vm = this;
    vm.ctrlName = 'MaleFemaleDiscrepancyCtrl';



    vm.model = {
      searchPanelToggle: true,
      width: window.screen.width,
      height:window.screen.height,
      isElasticLoadingVisible: false,
      searchOnGoing: false,
      totalNumberOfRecords:null,
      searchCriteria: {
        fromDate: null,
        toDate: null,
        noOfMales: 2


      },
      masterList: {
        fromDateFormatInvalid: false,
        toDateFormatInvalid: false,
        fromDateAfterToDate: false,
        largerSearchPeriod:false

      },
      maleFemaleDiscrepancyList: [],
      initialSearchDone: false
    };


    vm.clickOnSearch = function () {
      vm.model.searchPanelToggle = !vm.model.searchPanelToggle;
      vm.model.initialSearchDone = false;
    };


    var dataObject = [];
    var hotSettings = [];
    var hot;


    vm.submitSearch = function (params) {
      maleFemaleDiscrepancyService.searchMaleFemaleDiscrepancy(params,
        function (response) {
          vm.model.maleFemaleDiscrepancyList = response.maleFemaleDiscrepancyDTOS;
          vm.model.searchPanelToggle = false;
          vm.model.totalNumberOfRecords = response.maleFemaleDiscrepancyDTOS.length;
          dataObject = vm.dataObject();
          hotSettings = vm.hotSettings();
          hot = new Handsontable(hotElement, hotSettings);
        },
        function (error) {
          MessageService.error(error[0]);
        }
      );
    };



    function checkDateDifference() {
      if (!isDateFormatInvalid(vm.model.searchCriteria.fromDate) && !isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        if(getDatesDifference(vm.model.searchCriteria.fromDate, vm.model.searchCriteria.toDate) > 31){
          vm.model.masterList.largerSearchPeriod = true;
        } else {
          vm.model.masterList.largerSearchPeriod = false;
        }
      } else {
        vm.model.masterList.largerSearchPeriod = false;

      }
    }

    function getDatesDifference(fromDate, toDate){
      var diff = 0;
      if(!!fromDate && !!toDate){
        diff = moment(toDate, "DD/MM/YYYY").diff(moment(fromDate, "DD/MM/YYYY"), 'days')
      }
      return diff;
    }


    vm.dataObject = function () {
      var dataObject = [];

      for (var i in vm.model.maleFemaleDiscrepancyList) {
        dataObject.push({
          ROW_NUMBER : parseInt(i)+1,
          BLOCK_NAME: vm.model.maleFemaleDiscrepancyList[i].blockName,
          STARTD_DATE_TIME: vm.model.maleFemaleDiscrepancyList[i].blobkStartDateTime,
          FEMALE_COUNT: vm.model.maleFemaleDiscrepancyList[i].femaleCount,
          MALE_COUNT: vm.model.maleFemaleDiscrepancyList[i].maleCount


        })
      }
      return dataObject;
    };


    vm.hotSettings = function () {
      var hotSettings = {
        data: dataObject,
        undo: true,
        redo: true,
        copy: true,
        paste: true,
        copyRowsLimit: 1000000,

        columns: [
          {
            data: 'ROW_NUMBER',
            type: 'numeric',
            readOnly: true,
            manualColumnResize:13

          },
          {
            data: 'BLOCK_NAME',
            type: 'text',
            readOnly: true
          }, {
            data: 'STARTD_DATE_TIME',
            type: 'text',
            readOnly: true
          },  {
            data: 'MALE_COUNT',
            type: 'text',
            readOnly: true
          },
          {
            data: 'FEMALE_COUNT',
            type: 'text',
            readOnly: true
          }],

        stretchH: 'all',
        width: vm.model.width * 0.99,
        autoWrapRow: true,
        height: vm.model.height * 0.77,
        rowHeaders: true,
        colHeaders: [
          '',
          'Block Name',
          'Block Start Date',
          'Male Count',
          'Female Count'



        ]
      };

      return hotSettings;
    };

    var hotElement = document.querySelector('#hot');


    vm.changeSearchField = function (searchParams, flag) {
      setDateValidationFlags();
      var tempFromDate = moment(searchParams.fromDate, "DD/MM/YYYY").endOf('month').format("DD/MM/YYYY");
      if (tempFromDate != undefined && tempFromDate.toUpperCase() != "INVALID DATE" && flag != "toDate" ) {
        searchParams.toDate = tempFromDate;
        checkDateDifference();
      }else if (searchParams.fromDate != null && searchParams.toDate != null){
        checkDateDifference();
      }
      if (!vm.model.masterList.toDateFormatInvalid
        && !vm.model.masterList.fromDateFormatInvalid) {
        if (istoDateBeforeFromDate()) {
          vm.model.masterList.fromDateAfterToDate = true;
        } else {
          vm.model.masterList.fromDateAfterToDate = false;
        }
      } else {
        vm.model.masterList.fromDateAfterToDate = false;
      }


    };

    function setDateValidationFlags() {
      if (isDateFormatInvalid(vm.model.searchCriteria.fromDate)) {
        vm.model.masterList.fromDateFormatInvalid = true;
      } else {
        vm.model.masterList.fromDateFormatInvalid = false;
      }

      if (isDateFormatInvalid(vm.model.searchCriteria.toDate)) {
        vm.model.masterList.toDateFormatInvalid = true;
      } else {
        vm.model.masterList.toDateFormatInvalid = false;
      }
    }

    function isDateFormatInvalid(date) {
      return (!!date && !moment(date, "DD/MM/YYYY").isValid());
    }

    function istoDateBeforeFromDate() {
      return moment(vm.model.searchCriteria.toDate, "DD/MM/YYYY")
        .isBefore(
          moment(vm.model.searchCriteria.fromDate,
            "DD/MM/YYYY"));
    };

  }
}());
